import { FiAlertTriangle, FiCheck, FiTrash2 } from "react-icons/fi";
import { api } from "../services/api";
import { Modal, ModalButton } from "./Modal";

interface ModalProps {
  showModal: boolean;
  onHide(setModal: boolean): void;
  statusUpdated(): void;
  id: string;
  status: string;
}

export function ModalUpdateStatusTechVisitReport({
  showModal,
  onHide,
  statusUpdated,
  status,
  id,
}: ModalProps) {
  function updateStatusTechVisitReport() {
    api.patch(`/techVisitReport/status/${id}/${status}`).then(() => {
      onHide(false);
      statusUpdated();
    });
  }

  const isActivating = status === "A";

  return (
    <Modal
      isOpen={showModal}
      onClose={() => onHide(false)}
      title="Alterar Status"
      icon={<FiAlertTriangle size={20} />}
      variant={isActivating ? "success" : "danger"}
      footer={
        <>
          <ModalButton variant="cancel" onClick={() => onHide(false)}>
            Cancelar
          </ModalButton>
          <ModalButton
            variant={isActivating ? "success" : "danger"}
            onClick={updateStatusTechVisitReport}
          >
            {isActivating ? (
              <>
                <FiCheck size={16} />
                Ativar
              </>
            ) : (
              <>
                <FiTrash2 size={16} />
                Inativar
              </>
            )}
          </ModalButton>
        </>
      }
    >
      <div className="text-center py-4">
        <div
          className={`w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center ${
            isActivating ? "bg-green-100" : "bg-red-100"
          }`}
        >
          {isActivating ? (
            <FiCheck size={32} className="text-green-500" />
          ) : (
            <FiTrash2 size={32} className="text-red-500" />
          )}
        </div>
        <p className="text-gray-600 text-lg">
          Tem certeza que deseja{" "}
          <span className={isActivating ? "text-green-600 font-semibold" : "text-red-600 font-semibold"}>
            {isActivating ? "ativar" : "inativar"}
          </span>{" "}
          este relatório?
        </p>
        <p className="text-gray-400 text-sm mt-2">
          {isActivating
            ? "O relatório voltará a aparecer na listagem principal."
            : "O relatório será movido para os inativos."}
        </p>
      </div>
    </Modal>
  );
}
